import type { FaireProductEntity } from "../../entity_types/product";

export const p_gpzxtpntyt: FaireProductEntity = {
  token: "p_gpzxtpntyt",
  type: "product",
  name: "CWMM10450_SPORTS CHARM BRACELET SET BASKETBALL FOOTBALL",
  brandToken: "b_gd86yguu29",
  brandName: "NINEXIS",
  imageUrl:
    "https://cdn.faire.com/fastly/6893f09ea7f683c5c510687c215c77b4bd35f12e68a2a9751d27911ada17f5f2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/88e6efd1a6022fa52662f7172506ab3c5e58b3a60fc3166e0983cea71097c909.jpeg",
    "https://cdn.faire.com/fastly/25425ebfbf479eac343d3932887c02e921caf39c91a040def3ad8a45ce045e8c.jpeg",
    "https://cdn.faire.com/fastly/2b6add0b100552a1d3ae692ee7c00b6ae1da4012d77765c4406cffdb0f1d1e77.jpeg",
    "https://cdn.faire.com/fastly/0491fca9a4ce29362ba269814a2ed1434770d85cd4d1017530e522eb6782de96.jpeg",
    "https://cdn.faire.com/fastly/acd505494a4125ccae8cb8935e236ee5c72a7e7904320136ebd618ca888c2923.jpeg",
    "https://cdn.faire.com/fastly/08ab9c51b8865eeda6cea171438184dbd31fbb0462cdda3a7d547793b8e64a7d.jpeg",
    "https://cdn.faire.com/fastly/2f816584aa010c39cdbd8f6ee94e08e371b93274b54bb98aa09d46fd39c74d70.jpeg",
    "https://cdn.faire.com/fastly/2ecdb5f5cf954efbb4d74974c8d3811c79b325a6264e59e273722117ce8ad8b5.jpeg",
    "https://cdn.faire.com/fastly/50a01daeea69f55f7a9c68248886a88faf7476f3245700b54389fb1db1762c10.jpeg",
  ],
  priceDollars: 3.46,
  description:
    'SPORTS CHARM BRACELET SET BASKETBALL FOOTBALL\n100% GLASS\nSIZE   ONE SIZE \nELASTIC :DIAMETER: 2.36"(6 CM), PERIMETER: 7.09"(18 CM)\nMADE IN CHINA \n\nBOHEMIAN BEADED BRACELET, STRETCH BEAD BRACELET, BOHEMIAN JEWELRY,HEART BEAD BRACELET, LOVE CHARM BRACELET, ADJUSTABLE BEADED BRACELET,4-PACK BRACELET SET, ELASTIC BRACELET, NATURAL STONE BRACELET , ALLOY BRACELET,STACKABLE BRACELETS FOR WOMEN, BOHO CHIC GIFT SET, FESTIVAL JEWELRY,FRIENDSHIP GIFT SET, SUMMER BOHO STRETCH BRACELETS, MINIMALISTIC HEART BRACELET SET,BRACELET FOR WOMEN, WOMEN\'S BRACELET, WRISTBAND,BEADED BRACELET, STRETCH BRACELET, CRYSTAL BRACELET, CHARM BRACELET,GEMSTONE BRACELET, PEARL BRACELET, GOLD PLATED BRACELET, LEATHER BRACELET,MINIMALIST BRACELET, VINTAGE BRACELET, YOGA BRACELET,STACKING BRACELETS, FRIENDSHIP BRACELET, GIFT FOR HER, EVERYDAY JEWELRY',
  tags: [],
  msrpDollars: 6.93,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:35.656Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
